// extracted by mini-css-extract-plugin
export default {"container":"RequestQuote_container__htYsq","sectionHeading":"RequestQuote_sectionHeading__b70iu h4","defaultMessageLabel":"RequestQuote_defaultMessageLabel__wnT0Z p"};